var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g(_vm._b({tag:"component",class:_vm.$style.attributeLabel,attrs:{"fieldClasses":{
    clickableLabel: _vm.$style.clickableLabel,
    asterisk: _vm.$style.asterisk,
    fieldLabel: _vm.$style.fieldLabel
  }}},'component',_vm.groupLevelAttributeProps,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }